import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export function initEventCarousel() {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.js-events-carousel').forEach((el) => {
            const block = el.closest('.flex-events');
            if (!block) return;

            new Swiper(el, {
                modules: [Navigation, Pagination],
                slidesPerView: 1,
                loop: false,
                speed: 500,
                grabCursor: true,
                navigation: {
                    nextEl: block.querySelector('.js-vc-next'),
                    prevEl: block.querySelector('.js-vc-prev'),
                },
                pagination: {
                    el: block.querySelector('.js-vc-pagination'),
                    clickable: true,
                },
            });
        });
    });
}
